// Objetivo de proteína por persona — una sugerencia orientada al perfil
// elegido en el onboarding, nunca derivada de parámetros clínicos del
// paciente. Los valores son un punto de partida razonable, no una
// prescripción médica; cualquier copia en la UI debe presentarlo como
// "recomendado para tu perfil", nunca como una necesidad fisiológica.
const PROTEIN_G_PER_KG = {
  young_male: 1.8,
  menopause: 1.7,
  young_female: 1.6,
  pre_surgery: 1.6,
};

export function getProteinTarget(profile) {
  const perKg = PROTEIN_G_PER_KG[profile?.persona] || 1.6;
  return Math.round((profile?.weight_current || 80) * perKg);
}
